module.exports = __webpack_public_path__ + "static/media/not-say.86f3bf79.svg";